import { Component } from '@angular/core';
import { IEventAction } from 'src/app/@amiga-pyme/table-actions/components/ami-table-actions/ami-table-actions.interface';
import { TableActionsTemplate } from 'src/app/@amiga-pyme/table-actions/templates/table-actions.template';
import { TransferDocumentService } from './transfers-documents.service';
import { getTagColor } from '../../../../../helpers/tag-color.helpers';

@Component({
  templateUrl: './transfers-documents.component.html',
  selector: 'pg-transfers-documents'
})
export class TransfersDocumentComponent extends TableActionsTemplate {
  idDocument: number;

  constructor(private serviceBase: TransferDocumentService) {
    super('', serviceBase);
  }

  ngOnInit() {
    this.table.settings = {
      title: 'Reporte de traslados',
      columns: [
        { header: 'N° de documento', field: 'numberDocument' },
        { header: 'Sucursal de origen', field: 'branchStoreName' },
        { header: 'Sucursal de destino', field: 'branchStoreReceptionName' },
        {
          header: 'Fecha creación',
          field: 'createdAt',
          exportField: 'createdAtPeru',
          pipe: 'date'
        },
        { header: 'Estado', field: 'statusTransfer', tag: 'tagStatus' }
      ],
      exportData: true,
      filterColumns: true
    };

    this.table.actions = [
      {
        name: 'see-details',
        icon: 'pi pi-eye',
        class: 'p-button-rounded p-button-primary',
        pTooltip: 'Ver detalles'
      }
    ];

    this.initSubscriptions$();
  }

  initSubscriptions$() {
    this.suscriptionBase$ = this.serviceBase.getData$().subscribe((data) => {
      data = data.map((item) => {
        item.tagStatusColor = getTagColor(item.statusTransfer);
        item.createdAtPeru = this.formatDateTimePeru(
          this.parseUtcDateTime(item.createdAt)
        );
        return item;
      });
      this.table.data = data;
    });
  }

  private parseUtcDateTime(value: string): Date {
    const match = String(value || '').match(
      /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2}):(\d{2})/
    );

    if (!match) return new Date(value);

    const [, year, month, day, hours, minutes, seconds] = match;
    return new Date(
      Date.UTC(
        Number(year),
        Number(month) - 1,
        Number(day),
        Number(hours),
        Number(minutes),
        Number(seconds)
      )
    );
  }

  private formatDateTimePeru(date: Date): string {
    if (Number.isNaN(date.getTime())) return '';

    return new Intl.DateTimeFormat('es-PE', {
      timeZone: 'America/Lima',
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    }).format(date);
  }

  async onReciveAction(event: IEventAction) {
    if (event) {
      const { data, action } = event;
      if (action === 'see-details') {
        this.idDocument = data.id;
      }
    }
  }

  ngOnDestroy() {
    this.unsubscribeBase();
  }
}
